<template>
    <div>
        <v-row no-gutters>
            <v-col>
                <v-simple-table dense>
                    <tbody>
                        <tr>
                            <th>Date</th>
                            <td>{{formatDate(value.date)}}</td>
                        </tr>
                        <tr>
                            <th>Code</th>
                            <td>{{value.code}}</td>
                        </tr>
                        <tr>
                            <th>Reference</th>
                            <td>{{value.reference}}</td>
                        </tr>
                    </tbody>
                </v-simple-table>
            </v-col>
            <v-col>
                <v-simple-table dense>
                    <tbody>
                        <tr>
                            <th>State</th>
                            <td>
                                <PStatus :state="value.state" v-if="value"/>
                            </td>
                        </tr>
                        <tr>
                            <th>Supplier</th>
                            <td>{{ supplierName }}</td>
                        </tr>
                        <tr>
                            <th>Account</th>
                            <td>{{ supplierAccountName }}</td>
                        </tr>
                        <tr>
                            <th>Currency</th>
                            <td>{{currencyAbbreviation}}</td>
                        </tr>
                    </tbody>
                </v-simple-table>
            </v-col>
        </v-row>
        <v-row no-gutters>
            <v-col>
                <v-simple-table dense>
                    <thead>
                        <tr>
                            <th>#</th>
                            <th>Account</th>
                            <th>Amount</th>
                            <th>Amount</th>
                            <th>Amount</th>
                            <th>Description</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(line, index) in value.lines" :key="index">
                            <td>{{index + 1}}</td>
                            <td>{{line.ledger_account ? line.ledger_account.display_name : null}}</td>
                            <td>{{formatNumber(line.document_amount)}} {{value.account ? value.account.currency.abbreviation : null}}</td>
                            <td>{{formatNumber(line.base_amount)}} {{baseCurrency.abbreviation}} </td>
                            <td>{{formatNumber(line.amount)}} {{line.ledger_account.currency.abbreviation}}</td>
                            <td>{{line.description}}</td>
                        </tr>
                    </tbody>
                    <tfoot>
                        <tr class="font-weight-bold">
                            <td colspan="2">Total</td>
                            <td>{{formatNumber(getTotal(value.lines, 'document_amount'))}} {{value.account ? value.account.currency.abbreviation : null}}</td>
                            <td>{{formatNumber(getTotal(value.lines, 'base_amount'))}} {{baseCurrency.abbreviation}}</td>
                            <td colspan="2"></td>
                        </tr>
                    </tfoot>
                </v-simple-table>
            </v-col>
        </v-row>
        <v-row >
            <v-col>
                <v-simple-table dense>
                    <tbody>
                        <tr>
                            <th>
                                Notes
                            </th>
                            <td>{{value.notes}}</td>
                        </tr>
                    </tbody>
                </v-simple-table>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12" md="6">
                <v-simple-table dense>
                    <tbody>
                        <tr>
                            <th>Created By</th>
                            <td>
                                <span v-if="value.created_by">
                                    {{value.created_by.name}}
                                </span>
                            </td>
                        </tr>
                        <tr>
                            <th>Created At</th>
                            <td>{{value.created_at}}</td>
                        </tr>
                    </tbody>
                </v-simple-table>
            </v-col>
            <v-col cols="12" md="6">
                <v-simple-table dense>
                    <tbody>
                        <tr>
                            <th>Updated By</th>
                            <td>
                                <span v-if="value.updated_by">
                                    {{value.updated_by.name}}
                                </span>
                            </td>
                        </tr>
                        <tr>
                            <th>Updated At</th>
                            <td>{{value.updated_at}}</td>
                        </tr>
                    </tbody>
                </v-simple-table>
            </v-col>
        </v-row>
    </div>
</template>

<script>
import { formatNumber } from 'accounting';
import { getTotal } from '../../utils/accounting';
import PStatus from '../common/PStatus';

import moment from 'moment'
export default {
    name: "DebitNote",
    components: {
        PStatus
    },
    props: {
        value: Object
    },
    data() {
        return {
            baseCurrency: {
                id: 1,
                name: "Sudanese Pounds",
                abbreviation: "SDG"
            }
        }
    },
    computed: {
        currencyAbbreviation() {
            return this.value.account ? this.value.account.currency.abbreviation : null
        },
        supplierName() {
            return this.value.supplier ? this.value.supplier.display_name : null
        },
        supplierAccountName(){
            return this.value.account ? this.value.account.display_name : null 
        }
    },
    methods: {
        getTotal,
        formatNumber(n) {
            return formatNumber(n, 2);
        },
        formatDate(date) {
            return moment(date).format("YYYY-MM-DD");
        },
        formatDatetime(date) {
            return moment(date).format("YYYY-MM-DD HH:MM:SS");
        },
    }
}
</script>

<style>
</style>